import { useEffect } from "react";
import { Button, Box, Grid, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { black, gold } from "./HomeView";
import Photo from "./Photo.jsx";
import spinningRecord from "./images/spinning-record.gif";

const rsd_2026_photos = [
  {
    src: "images/rsd_2026/rsd-2026-1.avif",
    alt: "Asa sitting while a bicycle passes",
  },
  {
    src: "images/rsd_2026/rsd-2026-3.avif",
    alt: "Customers digging through crates outside",
  },
  {
    src: "images/rsd_2026/rsd-2026-2.avif",
    alt: "Asa sitting in front of the store",
  },
  {
    src: "images/rsd_2026/rsd-2026-12.avif",
    alt: "Customers holding up albums",
  },
  {
    src: "images/rsd_2026/rsd-2026-11.avif",
    alt: "Customer holding up an album",
  },
  {
    src: "images/rsd_2026/rsd-2026-8.avif",
    alt: "Customers digging through crates outside",
  },
  {
    src: "images/rsd_2026/rsd-2026-6.avif",
    alt: "Asa with a customer",
  },
  {
    src: "images/rsd_2026/rsd-2026-10.avif",
    alt: "Customers digging through crates outside",
  },
  {
    src: "images/rsd_2026/rsd-2026-9.avif",
    alt: "Customer holding up albums",
  },
  {
    src: "images/rsd_2026/rsd-2026-7.avif",
    alt: "Customer holding and looking at an album",
  },
  {
    src: "images/rsd_2026/rsd-2026-5.avif",
    alt: "Asa and friends behind the register",
  },
  {
    src: "images/rsd_2026/rsd-2026-4.avif",
    alt: "Customers digging through crates outside",
  },
];

const encounters_photos = [
  {
    src: "images/encounters/bill-kirchen.avif",
    alt: "Asa standing with Bill Kirchen",
    caption: "Bill Kirchen",
  },
  {
    src: "images/encounters/jakob-dylan.avif",
    alt: "Asa standing with Jakob Dylan",
    caption: "Jakob Dylan",
  },
  {
    src: "images/encounters/professor-louie.avif",
    alt: "Asa standing with Professor Louie",
    caption: "Professor Louie",
  },
];

const opening_day_photos = [
  {
    src: "images/opening_day/opening-day-1.avif",
    alt: "Customers shopping inside the store",
  },
  {
    src: "images/opening_day/opening-day-2.avif",
    alt: "Customers waiting in line outside",
  },
  {
    src: "images/opening_day/opening-day-3.avif",
    alt: "Customers flipping through albums",
  },
  {
    src: "images/opening_day/opening-day-4.avif",
    alt: "Customers shopping inside the store",
  },
  {
    src: "images/opening_day/opening-day-5.avif",
    alt: "Asa talking to a customer",
  },
  {
    src: "images/opening_day/opening-day-6.avif",
    alt: "Close-up of a stack of 45's",
  },
  {
    src: "images/opening_day/opening-day-7.avif",
    alt: "Asa with a customer",
  },
  {
    src: "images/opening_day/opening-day-8.avif",
    alt: "Customers shopping inside the store",
  },
  {
    src: "images/opening_day/opening-day-9.avif",
    alt: "Customers flipping through albums",
  },
  {
    src: "images/opening_day/opening-day-10.avif",
    alt: "Customers shopping in front of the wall of records",
  },
  {
    src: "images/opening_day/opening-day-11.avif",
    alt: "Customer holding up records and a cassette",
  },
  {
    src: "images/opening_day/opening-day-12.avif",
    alt: "Asa mingling outside the store",
  },
];

const GalleryView = ({ setCurrentView }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box bgcolor={black} padding={2} textAlign="center">
        <Typography variant="h2" fontFamily="Smokum" color={gold}>
          Railroad Records
        </Typography>
        <Button
          startIcon={<ArrowBack />}
          endIcon={<ArrowBack />}
          sx={{
            backgroundColor: `${gold}`,
            color: `${black}`,
            fontFamily: "Goblin One",
            marginTop: "15px",
          }}
          textAlign="center"
          onClick={() => {
            setCurrentView("home");
          }}
        >
          Go Back
        </Button>
      </Box>
      <Box display="flex" justifyContent="center">
        <Typography
          variant="h2"
          fontFamily="Smokum"
          marginTop="40px"
          sx={{ textDecoration: "underline" }}
        >
          Record Store Day
        </Typography>
      </Box>
      <Grid
        container
        overflow="auto"
        justifyContent="center"
        padding={3}
        paddingTop={0}
      >
        {rsd_2026_photos.map((photo) => (
          <Photo src={photo.src} alt={photo.alt} />
        ))}
      </Grid>
      <Box display="flex" justifyContent="center">
        <Typography
          variant="h2"
          fontFamily="Smokum"
          marginTop="40px"
          sx={{ textDecoration: "underline" }}
        >
          Asa's Encounters
        </Typography>
      </Box>
      <Grid
        container
        overflow="auto"
        justifyContent="center"
        padding={3}
        paddingTop={0}
      >
        {encounters_photos.map((photo) => (
          <Photo src={photo.src} alt={photo.alt} caption={photo.caption} />
        ))}
      </Grid>
      <Box display="flex" justifyContent="center">
        <Typography
          variant="h2"
          fontFamily="Smokum"
          marginTop="40px"
          sx={{ textDecoration: "underline" }}
        >
          Opening Day
        </Typography>
      </Box>
      <Grid
        container
        overflow="auto"
        justifyContent="center"
        padding={3}
        paddingTop={0}
      >
        {opening_day_photos.map((photo) => (
          <Photo src={photo.src} alt={photo.alt} />
        ))}
      </Grid>
      <Box padding={1} textAlign="center">
        <Button
          startIcon={<ArrowBack />}
          endIcon={<ArrowBack />}
          sx={{
            backgroundColor: `${black}`,
            color: `${gold}`,
            fontFamily: "Goblin One",
          }}
          textAlign="center"
          onClick={() => {
            setCurrentView("home");
          }}
        >
          Go Back
        </Button>
      </Box>

      <img
        src={spinningRecord}
        alt="Spinning Vinyl Record"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: "-1",
          opacity: "3%",
          width: "25%",
          minWidth: "450px",
        }}
      />
    </>
  );
};

export default GalleryView;
